import {
  Component,
  Input,
} from '@angular/core';
import { Subject } from 'rxjs';

@Component({
  selector: 'suka-accordion',
  template: `
    <ul class="accordion">
      <ng-content select="suka-accordion-item"></ng-content>
    </ul>
  `,
})
export class Accordion {
  protected _skeleton = false;

  openCloseItems = new Subject<boolean>();
  skeletons = new Subject<boolean>();

  @Input() multi = false;

  @Input()
  set skeleton(value: any) {
    this._skeleton = value;
    this.updateSkeletons();
  }

  get skeleton(): any {
    return this._skeleton;
  }

  protected updateSkeletons() {
    this.skeletons.next(this._skeleton);
  }
}
